import { Theme, styled } from '@material-ui/core';

export const ReactPlayerLoadingController = styled('div')<Theme, { loading?: boolean }>(
  ({ theme, loading }) => ({
    display: loading ? 'none' : 'inherit',
  })
);
